import React from 'react';
import { History } from '../../components/tools/History';
import { useToolExecution } from '../../hooks/useToolExecution';

export const HistoryTool = () => {
  const { checkCredits, deductCredits } = useToolExecution();

  return (
    <History onCostIncurred={(cost) => deductCredits(cost, 'History')} checkCredits={checkCredits} />
  );
};
